import { useShadow, useShadowStyle } from "../../util/wcUtil.ts"
import { sendEv } from '../../data/events.ts';
import { closePanel, onPanelButtons } from './modalPanel.ts';
import styleText from './shared-modal-styles.css?raw';

/**
 * Shown when the Paramate session has expired. Expired sessions are not
 * restored: that path proved too fragile (see docs/as-configurator.md, session
 * expiry section), so the only way out is a fresh project on a fresh session.
 * ProjectMixin does that on `as-intrn-discard-expired-session`.
 */
export class AsModalExpiredSession extends HTMLElement {
  static readonly tag = 'as-modal-expired-session' as const;

  get html() {
    return /*html*/`
      <div class="panel-content">
        <as-text dict-key="apps.general.expired-session.title" class="modal-title">Session Expired</as-text>
        <as-text dict-key="apps.general.expired-session.body" class="modal-desc">Your session has expired. Start a new session to continue.</as-text>
        <div class="row option-buttons">
          <as-text-button name="discard-expired-session" variant="primary" dict-key="modals.expired-session.start-new">Start New Session</as-text-button>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
    onPanelButtons(this, {
      'discard-expired-session': () => {
        closePanel(this);
        sendEv(this, 'as-intrn-discard-expired-session');
      },
    });
  }
}

if (!customElements.get(AsModalExpiredSession.tag)) {
  customElements.define(AsModalExpiredSession.tag, AsModalExpiredSession);
} else {
  console.warn('as-modal-expired-session already defined');
}
